
import JSZip from "jszip";
import { uploadToFirebase } from "../utils/firebase/firebase.utils";



export const handleFileSelect = async (selectedFiles, dPath, setCompressionStatus, setDownloadURL) => {
    // const selectedFiles = Array.from(event.target.files);
  
    // // Set size limit (15MB)
    // const maxTotalSize = 15 * 1024 * 1024; // 15MB
    // const totalSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);
  
    // if (totalSize > maxTotalSize) {
    //   alert("The total size of selected files exceeds the 15MB limit.");
    //   return;
    // }
  
    setCompressionStatus("Creating ZIP...");
  
    // Create a ZIP file using JSZip
    const zip = new JSZip();
    selectedFiles.forEach((file) => {
      zip.file(file.name, file); // Add each file to the ZIP
    });
  
    try {
      // Generate ZIP file as a Blob
      const zipBlob = await zip.generateAsync({ type: "blob" });
  
      setCompressionStatus("uploading");
      const downloadURL = await uploadToFirebase(zipBlob, "compressed_files/"+dPath+".zip");
  
      setCompressionStatus("completed");
      setDownloadURL(downloadURL);
      console.log("File available at:", downloadURL);
    } catch (error) {
      console.error("Error creating or uploading ZIP:", error);
      setCompressionStatus("Error during upload");
    }
};

export const generateRandomString = (length) => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
};